import { ccatsApi } from "../../apis/ccats";
import { authAction, alertConstants } from "./types";

export const loginUser = (userObj) => ({
  type: authAction.LOGIN_USER,
  payload: userObj,
});

export const logoutUser = () => ({
  type: authAction.LOGOUT_USER,
});

export const invalidUser = (message) => ({
  type: alertConstants.ERROR,
  payload: message,
});

export const validUser = (message) => ({
  type: alertConstants.SUCCESS,
  payload: message,
});

export const setLoading = (isLoading) => ({
  type: authAction.LOGIN_LOADING,
  payload: isLoading,
});

export const userLoginPost = (user) => async (dispatch) => {
  try {
    const response = await ccatsApi.post("/login", {
      UserName: user.username,
      Password: user.password,
    });
    const dataResponse = response.data;
    if (!dataResponse) {
      // handle invalid user here
      dispatch(invalidUser("invalid User"));
    } else {
      if (dataResponse) {
        localStorage.setItem("accessToken", dataResponse.AccessToken);
        localStorage.setItem("refreshToken", dataResponse.RefreshToken);
        const current_user = `${dataResponse.FIRSTNAME} ${dataResponse.LASTNAME}`;
        localStorage.setItem("currentUser", current_user);
        sessionStorage.setItem("userInfo", JSON.stringify(dataResponse));
        sessionStorage.setItem(
          "userSection",
          JSON.stringify(dataResponse.UserSection)
        );
        dispatch(loginUser(current_user));
      }
    }
  } catch ({ config, request }) {
    dispatch(invalidUser(request.response));
  }
};

export const userLogout = () => async (dispatch) => {
  dispatch(logoutUser());
};

export const GetProfilePost = () => async (dispatch) => {
  const token = localStorage.accessToken;
  if (token) {
    // user has logged in
    const currentUser = localStorage.currentUser;
    dispatch(loginUser(currentUser));
    // const response = await ccats.get("/profile", {
    //   Authorization: `Bearer ${token}`
    // });
    // if (response.message) {
    //   // An error will occur if the token is invalid.
    //   // If this happens, you may want to remove the invalid token.
    //   localStorage.removeItem("token");
    // } else {
    //   dispatch(loginUser(response.user));
    // }
  } else {
    dispatch(logoutUser());
  }
};

export const RefresAccesshToken = (token) => async () => {
  const refershToken = sessionStorage.refreshToken;
  const response = await ccatsApi.post("/auth/login/RefreshToken", {
    token: refershToken,
  });
  if (response.message) {
    // handle invalid user here
  } else {
    localStorage.setItem("refreshToken", response.jwt);
  }
};
